import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	// MACHINES
	[ModulesConfigMap[ModulesMap.MACHINES].CREATE_MACHINE]: {
		url: '/company/:companyId/machines/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES]: {
		url: '/company/:companyId/machines/',
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_PREVIEW_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/preview/',
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_POPUP_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/popup/',
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/',
	},
	[ModulesConfigMap[ModulesMap.MACHINES].DELETE_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINES].EDIT_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINES].PUT_MACHINE]: {
		url: '/company/:companyId/machines/:machineId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_SENSORS_VALUES]: {
		url: '/company/:companyId/machines/:machineId/sensor_values/',
	},
	[ModulesConfigMap[ModulesMap.MACHINES].GET_RAW_GPS_PARAMS]: {
		url: '/company/:companyId/machines/:machineId/raw_gps_params/',
	},
}
